
export default function About() {
  return (
    <section id="about" className="py-24 px-8 bg-gray-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-block px-6 py-2 bg-purple-100 text-purple-800 rounded-full text-xs uppercase font-semibold tracking-wide mb-12">
          ABOUT US
        </div>
        <h2 className="text-5xl font-extrabold text-gray-900 leading-tight mb-10">
          Building Trust Through Innovation
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
          LOCO d.o.o. specializes in creating sophisticated iOS applications that prioritize user privacy and device optimization. Our dedicated team combines technical expertise with user-centric design principles to deliver exceptional mobile experiences.
        </p>
      </div>
    </section>
  );
}
